/**
 * Curated Collections page logic.
 * Adds curated items to real Shopify cart, redirects to /cart for review.
 */
(function () {
  'use strict';

  var modal = document.getElementById('curated-modal');
  var modalTitle = document.getElementById('curated-modal-title');
  var modalImage = document.getElementById('curated-modal-image');
  var modalClose = document.getElementById('curated-modal-close');
  var checkoutBtn = document.getElementById('curated-checkout-btn');
  var itemsGrid = document.getElementById('curated-items-grid');

  var currentHandle = null;
  var currentProducts = [];
  var currentSize = null;
  var currentMode = 'toggle'; // 'single' | 'toggle' | 'mixed10'

  function updateToggleUI() {
    var optionsWrap = modal.querySelector('.curated-modal__options');
    var optionBtns = modal.querySelectorAll('.curated-modal__option');
    var desc = modal.querySelector('.curated-modal__desc');
    var btn5 = modal.querySelector('.curated-modal__option[data-size="5"]');
    var btn10 = modal.querySelector('.curated-modal__option[data-size="10"]');

    if (currentMode === 'mixed10') {
      // 10-piece variety: no size choice. Hide toggle, hide "choose size" prompt.
      if (optionsWrap) optionsWrap.style.display = 'none';
      if (desc) desc.style.display = 'none';
    } else {
      if (optionsWrap) optionsWrap.style.display = '';
      if (desc) desc.style.display = '';

      // Relabel toggle buttons based on mode
      if (currentMode === 'single') {
        if (btn5) btn5.textContent = '5-pc';
        if (btn10) btn10.textContent = '10-pc';
      } else {
        if (btn5) btn5.textContent = '5-Piece (1 of each)';
        if (btn10) btn10.textContent = '10-Piece (2 of each)';
      }
    }

    optionBtns.forEach(function (btn) { btn.classList.remove('btn--toggle-active'); });
  }

  function openModal(card) {
    currentHandle = card.dataset.collectionHandle;
    currentMode = card.dataset.mode || 'toggle';
    var title = card.dataset.collectionTitle;

    try {
      currentProducts = JSON.parse(card.dataset.products);
    } catch (e) {
      currentProducts = [];
    }

    if (modalTitle) modalTitle.textContent = title;

    var img = card.querySelector('.curated-card__image');
    if (modalImage && img) {
      modalImage.innerHTML = '<img src="' + img.src + '" alt="' + title + '" class="curated-modal__img">';
    }

    renderItemsPreview();

    currentSize = null;
    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Add to Cart';
    }

    updateToggleUI();

    // mixed10 has no user choice — auto-select size 10 and enable the button
    // (subject to the sold-out check inside selectSize).
    if (currentMode === 'mixed10') {
      selectSize(10);
    }

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function renderItemsPreview() {
    if (!itemsGrid) return;
    var html = '';
    currentProducts.forEach(function (p) {
      var soldOutClass = p.soldOut ? ' curated-modal__item--sold-out' : '';
      html += '<div class="curated-modal__item' + soldOutClass + '">';
      html += '<img src="' + p.image + '" alt="' + p.title.replace(/"/g, '&quot;') + '" class="curated-modal__item-img">';
      html += '<span class="curated-modal__item-name">' + p.title;
      if (p.soldOut) html += ' <span class="curated-modal__item-sold-out">— Out of stock</span>';
      html += '</span>';
      html += '<a href="/products/' + p.handle + '" class="curated-modal__item-view" title="View product">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
      html += '</a>';
      html += '</div>';
    });
    itemsGrid.innerHTML = html;
  }

  function hasSoldOutItem() {
    return currentProducts.some(function (p) { return p.soldOut; });
  }

  function closeModal() {
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  function selectSize(size) {
    currentSize = size;

    var optionBtns = modal.querySelectorAll('.curated-modal__option');
    optionBtns.forEach(function (btn) {
      btn.classList.toggle('btn--toggle-active', parseInt(btn.dataset.size, 10) === size);
    });

    if (checkoutBtn) {
      // If any product is sold out, the entire curated bundle can't be added
      if (hasSoldOutItem()) {
        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'Unavailable — Out of stock items';
      } else {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Add to Cart';
      }
    }
  }

  function addCuratedToCart() {
    if (!currentHandle || !currentSize || !currentProducts.length) return;
    if (hasSoldOutItem()) return; // safety: don't add if anything is sold out

    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Adding to cart...';
    }

    // Per-mode add logic:
    //   single  → 1 line, qty = currentSize (5 or 10) of that one product
    //   toggle  → legacy: 5 lines × (currentSize / 5) each
    //   mixed10 → 10 lines × 1 each (currentSize is 10 here)
    var invalid = [];
    var items = [];
    if (currentMode === 'single') {
      var p = currentProducts[0];
      if (p) {
        var id = parseInt(p.variantId, 10);
        if (id > 0) {
          items.push({ id: id, quantity: currentSize });
        } else {
          invalid.push(p.title || p.handle || '(unknown)');
        }
      }
    } else {
      var qtyEach = currentMode === 'toggle' ? (currentSize === 10 ? 2 : 1) : 1;
      currentProducts.forEach(function (p) {
        var id = parseInt(p.variantId, 10);
        if (id > 0) {
          items.push({ id: id, quantity: qtyEach });
        } else {
          invalid.push(p.title || p.handle || '(unknown)');
        }
      });
    }

    if (invalid.length) {
      console.warn('Curated collection "' + currentHandle + '" has products without an available variant:', invalid);
    }

    if (items.length === 0) {
      if (checkoutBtn) {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = 'Add to Cart';
      }
      alert('Sorry, none of the items in this collection are available right now.');
      return;
    }

    // Clear cart first, set target size, then add all items
    window.BundleManager.clearCart()
      .then(function () {
        localStorage.setItem('curate_collect_target_size', currentSize);
        return window.BundleManager.addItems(items);
      })
      .then(function (cart) {
        // If Shopify rejected the batch (e.g. one variant became unavailable
        // between page load and click), cart will be empty. Surface that
        // instead of redirecting to an empty cart page.
        if (!cart || !cart.item_count) {
          throw new Error('cart-empty-after-add');
        }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('Error adding curated bundle:', err);
        if (checkoutBtn) {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = 'Add to Cart';
        }
        var msg = err && err.message === 'cart-empty-after-add'
          ? 'Sorry, we couldn\'t add this collection to your cart. One or more items may be unavailable right now.'
          : 'There was an error adding items to your cart. Please try again.';
        alert(msg);
      });
  }

  // Event listeners
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.curated-card');
    if (card && !e.target.closest('.curated-modal-overlay')) {
      e.preventDefault();
      openModal(card);
      return;
    }

    var optionBtn = e.target.closest('.curated-modal__option');
    if (optionBtn) {
      e.preventDefault();
      selectSize(parseInt(optionBtn.dataset.size, 10));
      return;
    }
  });

  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      addCuratedToCart();
    });
  }
})();
